export default {
  home: 'Accueil',
  about: 'À propos',
  activity: {
    title: 'Activités',
    url: 'activites',
  },
  artwork: {
    title: 'Œuvres',
    url: 'oeuvres',
  },
  artworks: 'Œuvres',
  demo: 'Démo formulaire',
};



// WEBPACK FOOTER //
// ./src/config/locales/fr/breadcrumbs.js